import comp from "./AssessmentOtherLearningGoals";
export default comp;
